/** Format money with the row's currency (falls back to USD).
 *  Always 2 decimals. Uses Intl.NumberFormat which produces e.g. "RM 1,234.56", "$1,234.56".
 */
export function fmtMoney(value, currency = "USD") {
    const cur = (currency || "USD").toUpperCase();
    try {
        return new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: cur,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(value || 0);
    } catch {
        return `${cur} ${(value || 0).toFixed(2)}`;
    }
}

// Alias kept for callers that imported fmtMoneyPrecise — same behaviour as fmtMoney now.
export const fmtMoneyPrecise = fmtMoney;

export function currencySymbol(currency = "USD") {
    const cur = (currency || "USD").toUpperCase();
    try {
        const parts = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: cur,
        }).formatToParts(0);
        const sym = parts.find((p) => p.type === "currency");
        return sym ? sym.value : cur;
    } catch {
        return cur;
    }
}
